
import Vue from "vue";
import ImageIcon from "@/components/atoms/ImageIcon.vue";
import { News } from "@/lib/models/general";
import { NotificationsFromNolaNovel } from "@/lib/models";
import { NolaAnalytics, NolaItemId } from "@/lib/utils/analytics";

export default Vue.extend<{}, Methods, Computed, {}>({
  components: { ImageIcon },
  computed: {
    isActivePath() {
      return (name, excludePath) => {
        const { path } = this.$route;
        if (excludePath && path.startsWith(excludePath)) {
          return false;
        }
        return path.startsWith(name);
      };
    },
    isUnread() {
      const { latestNews, readLatestNews } = this;
      if (latestNews && readLatestNews) {
        return latestNews.updatedAt !== readLatestNews.updatedAt;
      }
      return true;
    },
    latestNews() {
      return this.$store.getters["generalModule/latestNews"];
    },
    readLatestNews() {
      return this.$store.getters["generalModule/readLatestNews"];
    },
    isUnreadFromNolaNovel() {
      const unreadNotifications = this.$store.getters["nolaNovelModule/notifications"](
        false
      ) as NotificationsFromNolaNovel;
      return unreadNotifications.items.length > 0;
    },
    hasUnreadAgentNotifications() {
      const notificationSummary = this.$store.getters["notificationModule/notificationSummary"];
      return notificationSummary?.unreadItemCount > 0;
    },
    hasUnreadInbox() {
      // エージェント通知またはNolaノベル通知に未読があれば表示
      return this.hasUnreadAgentNotifications || this.isUnreadFromNolaNovel;
    },
    isNolanovelOrAgentPath() {
      const { path } = this.$route;
      return path.startsWith("/nolanovel") || path.startsWith("/agent");
    },
  },
  methods: {
    onClickLink(name) {
      this.$gtm.trackEvent({
        event: "click_header_link",
        value: name,
      });
    },
    onClickInbox() {
      const nolaAnalytics = new NolaAnalytics(this.$gtm, this.$store);
      nolaAnalytics.logButtonEvent(NolaItemId.HeaderInboxClick);
    },
  },
});

interface Computed {
  isActivePath(name: string, excludePath?: string): boolean;
  isUnread: boolean;
  latestNews: News;
  readLatestNews: News;
  isUnreadFromNolaNovel: boolean;
  hasUnreadAgentNotifications: boolean;
  hasUnreadInbox: boolean;
  isNolanovelOrAgentPath: boolean;
}

interface Methods {
  onClickLink(name: string): void;
  onClickInbox(): void;
}
